@if ((agecPackaging$ | async)?.length) {
<div class="agec-packagings">
    <h-expansion-panel
        [contentPadding]="'0'"
        [role]="'accordion'"
        [backgroundColor]="secondaryColor"
        [collapsable]="collapsable"
        [showIcon]="collapsable"
        [collapsed]="!isOpen"
        (collapsedChange)="onCollapsedChange()"
        [borderBottomRemoved]="true"
        [headerLevel]="2">
        <ng-template [hExpansionPanelPart]="'header'">
            <div class="header">
                <h3 class="display-light" i18n="@@hermes.environment.packagings">nos emballages</h3>
            </div>
        </ng-template>
        <ng-template [hExpansionPanelPart]="'content'">
            <ul class="content" [class.content-opened]="isOpen">
                @for (package of agecPackaging$ | async; track package) {
                <li class="content-package">
                    <img class="media-wrap media-wrap-square" [attr.src]="package.imageUrl" alt="" />
                    <h3 class="paragraph-medium title">{{ package.title }}</h3>
                    @if ((displayNewFormatPackaging$ | async) === false) {
                    <ul class="description paragraph-small">
                        @if (package.recycledMaterial && package.recycledMaterial !== '0') {
                        <li>{{ package.recycledMaterial }}</li>
                        } @if (package.productRecyclability) {
                        <li>{{ package.productRecyclability }}</li>
                        }
                    </ul>
                    } @if (displayNewFormatPackaging$ | async) {
                    <ul class="description">
                        @if ( package.recycledMaterialAttribute && package.recycledMaterialAttribute?.data?.[0] !== '0'
                        ) {
                        <li>{{
                                package.recycledMaterialAttribute.value
                                    | replacePercent : package.recycledMaterialAttribute?.data?.[0]
                        }}</li>
                        } @if ( package.recycledMaterialAttribute && package.recycledMaterialAttribute?.data?.[0] ===
                        '0' ) {
                        <li
                            ><span i18n="@@hermes.environment.no-recycled-material"
                                >This product does not contain recycled material</span
                            ></li
                        >
                        } @if ( package.productRecyclabilityAttribute &&
                        (package.productRecyclabilityAttribute?.data?.[0] === 'VAL_01' ||
                        package.productRecyclabilityAttribute?.data?.[0] === 'VAL_02') ) {
                        <li>{{ package.productRecyclabilityAttribute.value }}</li>
                        } @if (package.reusabilityAttribute && package.reusabilityAttribute?.data?.[0] === 'VAL_164') {
                        <li>{{ package.reusabilityAttribute.value }}</li>
                        }
                    </ul>
                    }
                </li>
                }
            </ul>
        </ng-template>
    </h-expansion-panel>
</div>
}
